<div class="site-footer-cont w-screen flex justify-center pt-52">

    <div class="w-full flex-col desktop:w-desktop text-white font-normal">

        <div class="mb-6 mobile:p-2">
            <img class="w-40" src="assets/logos/gwc-regalia-hire-logo.png">
        </div>

        <div class="flex pb-8 mobile:p-2 mobile:flex-col">
            <div class="flex-grow">
                <div>
                    <div class="py-1">UC Dovedale Campus</div>
                    <div class="py-1">Wairarapa Building | Block ED15</div>
                    <div class="py-1">Ilam 8041</div>
                    <div class="py-1">Christchurch</div>
                </div>
            </div>
    
            <div class="flex-grow">
                <div class="flex py-1">
                    <div class="w-16">Phone:</div>
                    <div>+64 3 369 0604</div>
                </div>
                <div class="flex py-1">
                    <div class="w-16">Email:</div>
                    <div><a href="mailto:info@gwcregaliahire.nz">info&#64;gwcregaliahire.nz</a></div>
                </div>
    
                <div class="mt-4">
                    <div class="py-1">Opening Hours:</div>
                    <div class="py-1">Tuesday & Thursday 9:30am – 2.30pm</div>
                    <div class="py-5 text-gwc-text-body">HOURS ARE EXTENDED DURING GRADUATION WEEKS</div>
                </div>
            </div>
    
            <!-- <div class="flex-grow-0 w-1/3 h-48 bg-white ">
                Google Map
            </div> -->

        </div>
        
    </div>

</div>


<div class="copyright-cont w-screen text-white font-normal py-4 flex justify-center">
    <div class="message-cont text-xs w-full desktop:w-desktop mobile: px-2">
        &copy; Copyright 2021 GWC Regalia Hire. All rights reserved.    Privacy Policy    Site by Robertson Creative
    </div>
</div>

